export class AppOutOfDateUtils {
  static validVersionFromAllFragments(
    [minMajor, minMinor, minPatch]: string[],
    [appMajor, appMinor, appPatch]: string[]
  ): boolean {
    if (!minMajor || !minMinor || !minPatch) {
      return true;
    }
    const validMajor = AppOutOfDateUtils.validVersionFragment(minMajor, appMajor);
    const majorIsLarger = AppOutOfDateUtils.currentVersionFragmentIsLarger(minMajor, appMajor);
    const validMinor = majorIsLarger || AppOutOfDateUtils.validVersionFragment(minMinor, appMinor);
    const minorIsLarger = AppOutOfDateUtils.currentVersionFragmentIsLarger(minMinor, appMinor);
    const validPatch = majorIsLarger || minorIsLarger || AppOutOfDateUtils.validVersionFragment(minPatch, appPatch);
    return validMajor && validMinor && validPatch;
  }

  private static validVersionFragment(min: string, app: string): boolean {
    switch (true) {
      case !min:
      case /[a-zA-Z]/.test(min):
        return true;
      default:
        return AppOutOfDateUtils.parsedVersionNumberIsValid(min, app);
    }
  }

  private static parsedVersionNumberIsValid(min: string, app: string): boolean {
    const minAsFloat = Number.parseInt(min, 10);
    const appAsFloat = Number.parseInt(app, 10);
    if (!Number.isFinite(minAsFloat)) return true;
    return appAsFloat >= minAsFloat;
  }

  private static currentVersionFragmentIsLarger(min: string, app: string): boolean {
    switch (true) {
      case !min:
      case /[a-zA-Z]/.test(min):
        return false;
      default:
        return AppOutOfDateUtils.parsedVersionNumberIsLarger(min, app);
    }
  }

  private static parsedVersionNumberIsLarger(min: string, app: string): boolean {
    const minAsFloat = Number.parseInt(min, 10);
    const appAsFloat = Number.parseInt(app, 10);
    if (!Number.isFinite(minAsFloat)) return false;
    return appAsFloat > minAsFloat;
  }
}
